<template>
  <div class="video-container">
    <div class="header" v-if="fromPcPreview == 0">
      <div class="name">{{fileName}}</div>
      <div class='oper-icon'>
        <span> <i class="vido-download-icon" @click="downloadFile"><svg-icon icon-class="pdf-download" /> </i></span>
          <span @click.stop="closeWin">
           <i  style="color:#FFFFFF !important;" class="iconfont icon-close-solid mini "></i> 
         </span>
      </div>
    </div>
    <div :class="'video-content ' + (fromPcPreview == 0 ? '' : ' full-div ')">
      <div id="mse"></div>
    </div>

  </div>
</template>

<script>
import Player from 'xgplayer';
import {downloadUseForm} from "../../../../common-components/src/utils/fileUtil";
export default {
  name: "VideoPreview",
  props: {
    id: {
      type: Number,
      default: 0
    },
    fileName: {
      type: String,
      default: ''
    },
    previewUrl: {
      type: String,
      default: ''
    },
    fromPcPreview: {
      type: Number,
      default: 0
    },
  },
  commponents:{
     downloadUseForm
  },
  mounted() {
    this.previewXg();
  },
  methods: {
    previewXg() {
      let player = new Player({
        el: document.querySelector('#mse'),
        url: this.previewUrl,
        volume: 0.6,    // 初始音量
        autoplay: true,
        playsinline: true,
        // fitVideoSize: 'fixHeight',
        height: '100%',
        width: '100%',
        playbackRate: [0.5, 0.75, 1, 1.5, 2],   // 当前播放速度
        defaultPlaybackRate: 1,     // 播放速度设置为1
        errorTips: `请<span>刷新</span>试试`,
        screenShot: {
          saveImg: true,
          quality: 0.92,
          type: 'image/png',
          format: '.png'
        },
        keyShortcut: 'on',
        keyShortcutStep: { //设置调整步长
          currentTime: 15, //播放进度调整步长，默认10秒
          volume: 0.2 //音量调整步长，默认0.1
        }
      });
      player.once('complete', () => {
        try {
          player.play() // 尝试再次执行播放
          setTimeout(() => { // 500毫秒收检测
            if (!player.hasStart && player.currentTime === 0) { // hasStart返回false，并且播放时间还是0，那么就可以认为自动播放失效了
              player.play() // 尝试再次执行播放
            }
          }, 500)
        } catch (e) {
          console.log(e);
        }
      })
    },

    deleteFile(){
       this.$confirm("确定要删除文件/文件夹？","确认删除").then(() => {
          this.$api.post("/resapi/tw/resource-file/deleteFiles", {ids: this.id}).then(res => {
          if (res.success){
             this.$emit("delete")
          }else {
            this.$message.error(res.info ? res.info : "删除失败");
          }
        })
     

      });
    },
    downloadFile(){
      this.ucloading.showLoading();
      this.$api.post("/resapi/resource/download/downloadCheck", {ids: this.id}).then(res => {
        this.ucloading.hideLoading();
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        downloadUseForm(res.data.downloadUrl, {});
      }).catch(error => {
        this.ucloading.hideLoading();
        console.log(error);
      })
    },
   closeWin() {
      window.close();
    }
  }
}
</script>

<style lang=scss scoped>
.video-container {
  height: 100vh;
}
.video-container .header {
  background-color: #4d4d4d;
  height: 30px;
  background: #4d4d4d;
  display: flex;
  justify-content: space-between;
  line-height: 30px;
  .oper-icon {
    margin-right: 50px;
    i {
      margin-left: 20px;
      width: 20px;
    }
    .vido-download-icon:hover{
       cursor: pointer;
    }
  }
  .name {
    margin-left: 30px;
    color: white;
  }
}

.video-container .video-content {
  height: calc(100vh - 35px);
  background-color: #4d4d4d;
  display: flex;
  justify-content: space-around;
  overflow: hidden;

  &.full-div{
    height: 100vh;
  }
}
.video-container .video-content::v-deep .xgplayer-skin-default .xgplayer-progress-played {
     background-image: linear-gradient(-90deg,#20CCC6,#20c4cc);
}
.video-container .video-content::v-deep .xgplayer-skin-default .xgplayer-drag {
     background: #20CCC6;
}

</style>